import { Route, Routes, useLocation } from "react-router-dom";

import OldRoutes from "./OldRoutes";

const NewRoutes = ({
  navigateWorkspace,
  actualpage,
  version,
  userData,
  handleLoginAs,
  orgData,
  workspaceData,
  refreshFolders,
  masterData,
}) => {
  return (
    <Routes>
      <Route
        path="*"
        element={
          <OldRoutes
            path_prefix="/workspace/:id"
            navigateWorkspace={navigateWorkspace}
            version={version}
            userData={userData}
            orgData={orgData}
            workspaceData={workspaceData}
            refreshFolders={refreshFolders}
            actualpage={actualpage}
            handleLoginAs={handleLoginAs}
            masterData={masterData}
          ></OldRoutes>
        }
      />
    </Routes>
  );
};

export default NewRoutes;
